// extracted by mini-css-extract-plugin
export default {"select-panel":"OIiwGpV","select-panel-light":"ozWd33R"};